<template>
  <div class="topBar">
    <div class="left">
      <div class="left-left">
        {{secend}}
      </div>
      <div class="left-right">
        <div>{{time}}</div>
        <div>{{week}}</div>
      </div>
    </div>
    <p class="center">跨境大数据平台</p>
    <!-- <div class="time">
      <el-date-picker
        v-model="date"
        type="year"
        format="yyyy"
        value-format="yyyy"
        :clearable="false"
        @change="timeChange"
        placeholder="选择日期">
      </el-date-picker>
    </div> -->
    <img v-if="menuItem.orderTracking" src="@/assets/images/home/report.png" class="orderBtn" @click="doSearchOrder" title="订单跟踪">
    <img v-if="menuItem.searchAll" src="@/assets/images/home/search.png" class="search" @click="toSearch">
    <div class="right" style="cursor: pointer;" @click="showTipes">
      {{form.userName}}
      <div class="right-list" v-if="tipsShow">
        <div style="border-bottom:1px solid #fff;cursor: pointer;" @click.stop="singleClick">个人中心</div>
        <div style="cursor: pointer;" @click="loginOut">退出登录</div>
      </div>
    </div>
    <el-dialog
      title="个人中心"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class='reportDialog1'
      :visible.sync="sigleShow"
    >
      <div class='mask'></div>
      <div class='ux-panel' style="500px">
        <!-- <div class='title'>个人中心</div> -->
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="登陆账号" prop="dtcUName">
            <el-input v-model="form.fullName" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-input v-model="form.gender"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="describe">
            <el-input v-model="form.describe"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input v-model="form.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item label="座机" prop="telephone">
            <el-input v-model="form.telephone"></el-input>
          </el-form-item>
        </el-form>
        <!-- <div class='close' @click='sigleShow = false'>
          <img src='@/assets/images/home/close.png'/>
        </div> -->
      </div>
    </el-dialog>
    <search-order-compontent ref="searchOrderCompontentRef"></search-order-compontent>
  </div>
</template>

<script>
import apiPath from '@config/api.json'
import common from '@/utils/common'
import searchOrderCompontent from '@/components/main/bigData/order/searchDialog'
// import languageObj from '@/utils/lan.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {searchOrderCompontent},

  data () {
    return {
      menuItem: {
        searchAll: false, // 搜索全部
        orderTracking: false // 订单跟踪
      },
      time: '',
      secend: '',
      date: '',
      form: {
        fullName: '',
        name: '',
        gender: '',
        describe: '',
        phoneNumber: '',
        telephone: ''
      },
      rules: {
        fullName: [
          { required: false, message: '' }
        ],
        name: [
          { required: true, message: '' }
        ],
        gender: [
          { required: true, message: '' }
        ],
        describe: [
          { required: true, message: '' }
        ],
        phoneNumber: [
          { required: true, message: '' }
        ],
        telephone: [
          { required: true, message: '' }
        ]
      },
      tipsShow: false,
      sigleShow: false,
      week: '',
      timer: null
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.searchAll = common.isShowItem('searchAll', setListMenu)
      this.menuItem.orderTracking = common.isShowItem('orderTracking', setListMenu)
    }
  },

  mounted () {
    this.date = this.homeTime || new Date().getFullYear() + ''
    let that = this
    let data = sessionStorage.getItem('user')
    if (data) {
      data = JSON.parse(data)
    }
    this.form = {
      userName: data.userName,
      fullName: data.fullName,
      name: data.name,
      gender: data.gender,
      describe: data.roles.map(item => { return item.describe }).join(','),
      phoneNumber: data.phoneNumber,
      telephone: data.telephone
    }
    clearInterval(that.timer)
    this.timer = setInterval(() => {
      that.getTime()
    }, 1000)
  },

  methods: {
    ...mapMutations(['setHomeTime']),
    loginOut () {
      this.$ajax({
        method: 'get',
        url: apiPath.common.loginOut
      }).then(res => {
        if (res.status === 0) {
          this.$router.replace({
            name: 'login'
          })
          common.successInfoTip('已成功退出')
        }
      })
    },
    showTipes () {
      this.tipsShow = true
    },
    singleClick () {
      this.tipsShow = false
      this.sigleShow = true
      this.$forceUpdate()
    },
    toSearch () {
      this.$router.push('/main/bigData/search')
    },
    getTime () {
      this.secend = common.formatDate(new Date().getTime()).split(' ')[1]
      this.time = common.getDay()
      this.week = common.getWeek()
    },
    timeChange () {
      this.setHomeTime(this.date)
    },
    // 新单跟踪搜索弹窗
    doSearchOrder () {
      this.$refs.searchOrderCompontentRef && this.$refs.searchOrderCompontentRef.init()
    }
  }
}
</script>

<style lang="scss" scoped>
  .topBar{
    width: 100%;
    height: 95px;
    background: url('~@/assets/images/home/topbar-bg.png') no-repeat -266px 0;
    position: relative;
    color:#fff;
    .search{
      width: 20px;
      height: 20px;
      position: absolute;
      right: 240px;
      top: 35px;
      z-index: 999;
      cursor: pointer;
    }
    .orderBtn{
      width: 20px;
      height: 20px;
      position: absolute;
      right: 270px;
      top: 35px;
      z-index: 999;
      cursor: pointer;
    }
    .left{
      display: flex;
      align-items: center;
      position: absolute;
      left: 22px;
      top: 20px;
      .left-left{
        height: 46px;
        font-size: 46px;
        font-family: SFU DIN;
        font-weight: normal;
        line-height: 46px;
        margin-right: 8px;
      }
      .left-right{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .center{
      font-size: 44px;
      font-family: HYLingXinJ;
      font-weight: 400;
      // width: 476px;
      position: absolute;
      top:40%;
      left:50%;
      transform: translate(-50%, -50%);
      height: 43px;
      line-height: 43px;
      letter-spacing: 10px;
      text-shadow: 0px 5px 8px rgba(6,24,60,0.14);
      background: linear-gradient(0deg, #2FA4EE 0%, #FFFFFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .time{
      position: absolute;
      right: 305px;
      top: 28px;
    }
    .right{
      position: absolute;
      right: 22px;
      top: 26px;
      width: 188px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 16px;
      padding-left: 18px;
      color: #E2F0FE;
      background: url('~@/assets/images/home/out.png') no-repeat 0 0;
      .right-list{
        position: absolute;
        right: 22px;
        top: 46px;
        width: 188px;
        border-radius: 8px;
        // height: 35px;
        // padding:2px 0;
        background: rgba(71, 90, 179, 0.8);
        z-index: 999;
        div{
          height:35px;
          line-height: 35px;
          width: 188px;
          text-align: center;
        }
      }
    }
  }
</style>
<style lang="scss">
  .el-year-table today tr td .cell{
    color: #606266;
    font-weight: 500;
  }
  .reportDialog1{
    width: 90% !important;
    // min-height: 770px !important;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    margin-left: 5% !important;
  }
  .topBar{
    .time{
      .el-input__inner{
        background: transparent;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/topBar.vue